import { cpqAxios, cpqAxiosWithToken } from '../http-common';
import { Congiguration } from '../Constants/AppConstants';

class ServiceDistributionService {
    saveUpdateServiceDistribution(updateServiceDistribution) {
        return cpqAxiosWithToken.post("UtilizationDistribution/UpdateSaveUtilizationDistributions", updateServiceDistribution);
    }
    
}
export default new ServiceDistributionService();